export function getTypeVariations(word: string): string[] {
  const variations = [word];

  if (!word.endsWith('s')) {
    variations.push(`${word}s`);
  }

  if (word.endsWith('s') && word.length > 1) {
    variations.push(word.slice(0, -1));
  }

  return variations;
}

export function checkTypeMatch(productType: string, configuredTypes: string[]): boolean {
  if (!productType) return false;

  const productTypeVariations = getTypeVariations(productType);

  for (const configType of configuredTypes) {
    const configTypeVariations = getTypeVariations(configType);

    for (const productVariation of productTypeVariations) {
      if (configTypeVariations.includes(productVariation)) {
        return true;
      }
    }
  }

  return false;
}
